import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getQualifications,
  getSelectedQualificationsById,
  getShowNewQualificationModal,
} from 'selectors/admin/work-orders/details/qualifications';
import QualificationsViewer from './QualificationsViewer';
import {
  optionSelected,
  qualificationSelected,
  setShowNewQualificationModal,
} from 'actions/admin/work-orders/details/qualifications';
import './QualificationsContainer.css';
import NewQualificationModal from './NewQualificationModal';
import { QualificationTypeEnum } from 'domain/qualification-type-enum';
import PropTypes from 'prop-types';

class QualificationsContainer extends Component {
  static propTypes = {
    readOnly: PropTypes.bool,
  };

  static defaultProps = {
    readOnly: false,
  };

  render() {
    return (
      <div className="qualifications-container">
        <div className="h3">Qualifications</div>

        <QualificationsViewer
          qualifications={this.mapQualifications(this.props.qualifications)}
          readOnly={this.props.readOnly}
          onOptionSelected={this.handleOptionSelected}
          onQualificationSelected={this.handleQualificationSelected}
        />

        {!this.props.readOnly && (
          <div className="qualifications-button-container">
            <input
              type="button"
              className="btn button button-orange"
              value="Add Qualification"
              onClick={this.handleAddQualification}
            />
          </div>
        )}

        {this.props.showNewQualificationModal && <NewQualificationModal />}
      </div>
    );
  }

  handleAddQualification = (event) => {
    event.preventDefault();
    this.props.dispatch(setShowNewQualificationModal(true));
  };

  handleQualificationSelected = (qualificationId) => {
    this.props.dispatch(qualificationSelected(qualificationId));
  };

  handleOptionSelected = (qualificationId, option) => {
    this.props.dispatch(optionSelected(qualificationId, option));
  };

  mapQualifications = (qualifications) => {
    return qualifications.map((qualification) => {
      const selectedQualification = this.props.selectedQualificationsById[
        qualification.id
      ];
      return {
        id: qualification.id,
        label: qualification.label,
        options: qualification.options.map((option, index) => {
          let selected = false;
          if (
            selectedQualification !== undefined &&
            selectedQualification.option !== null
          ) {
            selected = selectedQualification.option.label === option;
          }
          return { id: index, label: option, selected: selected };
        }),
        selected: selectedQualification !== undefined,
        trade:
          qualification.trade !== null && qualification.trade !== undefined
            ? {
                value: qualification.trade.value,
                label: qualification.trade.label,
              }
            : null, // trade could be undefined
        type: QualificationTypeEnum.get(qualification.q_type),
      };
    });
  };
}

export default connect((state) => {
  return {
    qualifications: getQualifications(state), // loaded on ProposalModal (defaults) or ProposalApprovalModal
    selectedQualificationsById: getSelectedQualificationsById(state), // loaded on ProposalModal (defaults) or ProposalApprovalModal
    showNewQualificationModal: getShowNewQualificationModal(state),
  };
})(QualificationsContainer);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/qualifications/QualificationsContainer.js